/**
 * assets/product-mee-bestellen.js
 * Gedrag van snippets/product-mee-bestellen.liquid (16-10-2026).
 * Toevoegknop: POST naar /cart/add.js (GA4 vangt dat zelf af als add_to_cart), daarna de
 * winkelwagenlade verversen en openen, zoals assets/cadeaukaart-pagina.js. Lukt het niet,
 * dan een melding en de knop weer bruikbaar; de gewone koopknop wordt nooit aangeraakt.
 * Meting: Amplitude-event recommendation_added_to_cart met bron pdp_mee_bestellen.
 */
(function () {
  'use strict';
  document.addEventListener('click', function (e) {
    var knop = e.target && e.target.closest ? e.target.closest('[data-mee-variant]') : null;
    if (!knop || knop.getAttribute('aria-busy') === 'true') return;
    e.preventDefault();
    var blok = knop.closest('[data-mee-bestellen]');
    var status = blok ? blok.querySelector('[data-mee-status]') : null;
    var tekst = knop.textContent;
    var variant = Number(knop.getAttribute('data-mee-variant'));
    knop.setAttribute('aria-busy', 'true');
    knop.textContent = 'Bezig';
    window.fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variant, quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    }).then(function () {
      knop.textContent = 'Toegevoegd';
      knop.classList.add('is-toegevoegd');
      if (status) status.textContent = 'Toegevoegd aan je winkelwagen.';
      try {
        if (window.vcAmplitude && typeof window.vcAmplitude.track === 'function') {
          window.vcAmplitude.track('recommendation_added_to_cart', {
            bron: 'pdp_mee_bestellen',
            product_id: knop.getAttribute('data-mee-product'),
            hoofdproduct_id: blok ? blok.getAttribute('data-mee-bron') : null
          });
        }
      } catch (_) {}
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      if (window.CartDrawer && typeof window.CartDrawer.open === 'function') window.CartDrawer.open();
      setTimeout(function () {
        knop.textContent = tekst;
        knop.classList.remove('is-toegevoegd');
        knop.removeAttribute('aria-busy');
      }, 2500);
    }).catch(function () {
      knop.textContent = tekst;
      knop.removeAttribute('aria-busy');
      if (status) status.textContent = 'Toevoegen lukte niet. Probeer het opnieuw of open het product.';
    });
  });
})();
